import { Card } from "../../design-v2";
import AvailabilitySection from "./trainingProfileSections/AvailabilitySection";
import CardioProfileSection from "./trainingProfileSections/CardioProfileSection";
import EnvironmentSection from "./trainingProfileSections/EnvironmentSection";
import ExercisePreferenceSection from "./trainingProfileSections/ExercisePreferenceSection";
import ExperienceSection from "./trainingProfileSections/ExperienceSection";
import GoalsSection from "./trainingProfileSections/GoalsSection";
import MovementConstraintsSection from "./trainingProfileSections/MovementConstraintsSection";

const SECTION_COMPONENTS = {
  goals: GoalsSection,
  experience: ExperienceSection,
  availability: AvailabilitySection,
  environment: EnvironmentSection,
  movementConstraints: MovementConstraintsSection,
  exercisePreference: ExercisePreferenceSection,
  cardioProfile: CardioProfileSection,
};

export default function TrainingProfileForm({
  sectionId,
  draft,
  onChange,
  fieldErrors,
  options,
}) {
  const SectionComponent = SECTION_COMPONENTS[sectionId];

  if (!SectionComponent) {
    return (
      <Card tone="raised" padding="md">
        <p className="lz-settings-muted-text">
          This settings screen is not available yet.
        </p>
      </Card>
    );
  }

  // The section is rendered on its own. The trailing "Signal behavior in V1"
  // card that used to follow every training-profile screen was an internal
  // explanation of the caution/blocked signal model, not product copy, and was
  // removed. The caution, blocked, AI-detected and confirmed semantics it
  // described are unchanged and still live in `MovementConstraintsSection` and
  // the backend rules.
  return (
    <SectionComponent
      draft={draft}
      onChange={onChange}
      fieldErrors={fieldErrors}
      options={options}
    />
  );
}
